import { render, staticRenderFns } from "./ConstructorMatchCheckbox.vue?vue&type=template&id=51a1d218&scoped=true&"
import script from "./ConstructorMatchCheckbox.vue?vue&type=script&lang=js&"
export * from "./ConstructorMatchCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a1d218",
  null
  
)

export default component.exports